/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const GetOperationR200ResponseArtifactsInnerTagEnum = {
    FastBridgeErrors: 'sync_fast_bridge_errors',
    FastBridgeMathPlacements: 'sync_fast_bridge_math_placements',
    FastBridgeElaPlacements: 'sync_fast_bridge_ela_placements',
    NweaMapMathPlacements: 'sync_nwea_map_math_placements',
    NweaMapElaPlacements: 'sync_nwea_map_ela_placements'
};
/**
 * Check if a given object implements the GetOperationR200ResponseArtifactsInner interface.
 */
export function instanceOfGetOperationR200ResponseArtifactsInner(value) {
    if (!('tag' in value) || value['tag'] === undefined)
        return false;
    if (!('url' in value) || value['url'] === undefined)
        return false;
    return true;
}
export function GetOperationR200ResponseArtifactsInnerFromJSON(json) {
    return GetOperationR200ResponseArtifactsInnerFromJSONTyped(json, false);
}
export function GetOperationR200ResponseArtifactsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tag': json['tag'],
        'url': json['url'],
    };
}
export function GetOperationR200ResponseArtifactsInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'tag': value['tag'],
        'url': value['url'],
    };
}
